module.exports = __webpack_public_path__ + "img/logo1.41efdaf3.png";